import { ExternalTheme } from "../../../themes/external-theme/external-theme.js";
import "../../../constants/breakpoints/breakpoints.js";
import "../../../constants/create-theme/create-theme.js";
import "@mui/material/styles";
import "../../../constants/colors/palette.js";
import "../../../themes/shadows/shadows.js";
import "@mui/material";
import "../../../themes/typography/typography.js";
import "../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "../../../themes/alert/alert.js";
import "react/jsx-runtime";
import "../../../themes/alert/components/ErrorIcon/ErrorIcon.js";
import "@mui/material/SvgIcon/index.js";
import "../../../themes/alert/components/InfoIcon/InfoIcon.js";
import "../../../themes/alert/components/SuccessIcon/SuccessIcon.js";
import "../../../themes/alert/components/WarningIcon/WarningIcon.js";
import "../../../themes/button/button.js";
import "../../../themes/button/styles/external/bordered.styles.js";
import "color-alpha";
import "../../../themes/button/styles/external/filled.styles.js";
import "../../../themes/button/styles/internal/bordered.styles.js";
import "../../../themes/button/styles/internal/borderless.styles.js";
import "../../../themes/button/styles/internal/filled.styles.js";
import "../../../themes/button/styles/internal/shadowed.styles.js";
import "../../../themes/checkbox/checkbox.js";
import "../../../themes/checkbox/components/CheckedIcon/CheckedIcon.js";
import "../../../themes/checkbox/components/IndeterminateIcon/IndeterminateIcon.js";
import "../../../themes/form-control-label/form-control-label.js";
import "../../../themes/radio/radio.js";
import "../../../themes/switch/switch.js";
const dropdownContainer = (orientation) => ({
  position: "absolute",
  top: "32px",
  left: orientation === "right" ? "-100%" : "unset",
  borderRadius: "10px"
});
const dropdownContent = {
  background: ExternalTheme.palette.common.white,
  borderRadius: "10px",
  height: "fit-content",
  overflow: "hidden"
};
const relativeContainer = {
  position: "relative"
};
const hoverableContainer = {
  position: "absolute",
  left: 0,
  right: 0,
  top: 0,
  height: "32px"
};
export {
  dropdownContainer,
  dropdownContent,
  hoverableContainer,
  relativeContainer
};
